export const skipEmptyValues = (object) => {
  return Object.keys(object).reduce((acc, key) => (object[key] ? { ...acc, [key]: object[key] } : acc), {});
};
